import { z } from 'zod'
import { oc } from '@orpc/contract'

export const stediProviderOptionSchema = z.object({
  id: z.string(),
  name: z.string(),
  npi: z.string(),
})

/**
 * The organization's provider records on Stedi's side, for the Provider Operations picker.
 * Under `/v2/organizations/`, not `/v2/super/`: the gate is Provider Operations access to
 * the Organization, not super admin (PD-1961). The Bridge list stays super-admin only.
 *
 * Two non-error empty states, and the caller must tell them apart:
 * - `configured: false` — no Stedi key saved; render "save the key first".
 * - `testModeRestricted: true` — the saved key is a `test_…` key, and Stedi's enrollments
 *   product (which owns provider records) refuses test mode wholesale. The picker cannot
 *   be filled, so the caller falls back to manual id entry.
 */
export const listOrganizationStediProviders = oc
  .route({ method: 'GET', path: '/v2/organizations/{organizationId}/stedi-providers' })
  .input(z.object({ organizationId: z.string().min(1) }))
  .output(
    z.object({
      configured: z.boolean(),
      testModeRestricted: z.boolean(),
      providers: z.array(stediProviderOptionSchema),
    }),
  )
